export default "__VITE_ASSET__Ci$0DFID__"